/** On Odoo Online the database is the first part of the address: acme for acme.odoo.com. */
export const guessOdooDatabase = (baseUrl: string): string => {
	const host = baseUrl.trim().replace(/^https?:\/\//i, '').split(/[/:?#]/)[0] ?? '';
	const match = /^([a-z0-9-]+)\.odoo\.com$/i.exec(host);
	return match ? match[1] : '';
};
